import { Component } from '@theme/component';

/** Return the final editorial CTA to the existing purchase button. */
class KindneoPdpReturn extends Component {
  /** @param {MouseEvent} event */
  returnToPurchase(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.querySelector('.product-information .add-to-cart-button');
    if (!(target instanceof HTMLButtonElement)) return;
    event.preventDefault();
    target.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    target.focus({ preventScroll: true });
  }
}
if (!customElements.get('kn-pdp-return')) customElements.define('kn-pdp-return', KindneoPdpReturn);
